/**
 * @readonly
 * @enum {string}
 */
export const Trip = Object.freeze({
    AVERAGE_SPEED: 'averageSpeed',
    AVG_SPEED: 'avgSpeed',
    CARBON_FOOTPRINT: 'carbonFootprint',
    COASTING_DISTANCE: 'coastingDistance',
    COASTING_REFERENCE_TIME: 'coastingReferenceTime',
    COASTING_TIME: 'coastingTime',
    COMMENT: 'comment',
    CONSTANT_SPEED_REFERENCE_TIME_EXTRA_URBAN: 'constantSpeedReferenceTimeExtraUrban',
    CONSTANT_SPEED_REFERENCE_TIME_MOTORWAY: 'constantSpeedReferenceTimeMotorway',
    CONSTANT_SPEED_REFERENCE_TIME_URBAN: 'constantSpeedReferenceTimeUrban',
    CONSTANT_SPEED_TIME_EXTRA_URBAN: 'constantSpeedTimeExtraUrban',
    CONSTANT_SPEED_TIME_MOTORWAY: 'constantSpeedTimeMotorway',
    CONSTANT_SPEED_TIME_URBAN: 'constantSpeedTimeUrban',
    CONTACT: 'contact',
    CONTROL_FLAGS: 'controlFlags',
    CRUISE_CONTROL_DISTANCE: 'cruiseControlDistance',
    CRUISE_CONTROL_PERCENT: 'cruiseControlPercent',
    DISTANCE: 'distance',
    DRIVER_ID: 'driverId',
    DURATION: 'duration',
    END_ADDRESS_ID: 'endAddressId',
    END_BATTERY_ENERGY: 'endBatteryEnergy',
    END_BATTERY_LEVEL: 'endBatteryLevel',
    END_LOCATION_DESCRIPTION: 'endLocationDescription',
    END_ODOMETER: 'endOdometer',
    END_POSITION: 'endPosition',
    END_TIME: 'endTime',
    FUEL_CONSUMPTION: 'fuelConsumption',
    FUEL_CONSUMPTION_REFERENCE: 'fuelConsumptionReference',
    FUEL_TYPE: 'fuelType',
    GREEN_SPEED_REFERENCE_TIME: 'greenSpeedReferenceTime',
    GREEN_SPEED_TIME: 'greenSpeedTime',
    HIGH_REVVING_AVERAGE: 'highRevvingAverage',
    HIGH_REVVING_REFERENCE_TIME: 'highRevvingReferenceTime',
    HIGH_REVVING_TIME: 'highRevvingTime',
    IDLE_TIME: 'idleTime',
    LAST_MODIFY_TIME: 'lastModifyTime',
    LAST_MODIFY_USER_NAME: 'lastModifyUserName',
    LICENSE_PLATE_NO: 'licensePlateNo',
    MAX_SPEED: 'maxSpeed',
    OBJECT_ID: 'objectId',
    OBJECT_NAME: 'objectName',
    OPTI_DRIVE_SCORE: 'optiDriveScore',
    PRIVATE_DISTANCE_PART: 'privateDistancePart',
    PURPOSE: 'purpose',
    RULES: 'rules',
    START_ADDRESS_ID: 'startAddressId',
    START_BATTERY_ENERGY: 'startBatteryEnergy',
    START_BATTERY_LEVEL: 'startBatteryLevel',
    START_LOCATION_DESCRIPTION: 'startLocationDescription',
    START_ODOMETER: 'startOdometer',
    START_POSITION: 'startPosition',
    START_TIME: 'startTime',
    TRIP_ID: 'tripId',
    TRIP_MODE: 'tripMode'
})
